class ProductCardVariantSelector extends HTMLElement {
  connectedCallback() {
    this.select = this.querySelector('select');
    this.card = this.closest('product-card');

    if (!this.select || !this.card) return;

    this.select.addEventListener('change', this.handleChange);
    this.sync();
  }

  disconnectedCallback() {
    this.select?.removeEventListener('change', this.handleChange);
  }

  handleChange = () => {
    this.sync();
  };

  sync() {
    const option = this.select?.selectedOptions[0];
    if (!option || !this.card) return;

    const variantId = option.value;
    const available = option.dataset.available === 'true';
    const price = option.dataset.price;
    const url = option.dataset.url;
    const mediaId = option.dataset.mediaId;
    const featuredMediaUrl = option.dataset.featuredMediaUrl;

    const addToCartButton = this.card.querySelector('.add-to-cart__button button');

    if (!variantId) {
      if (addToCartButton instanceof HTMLButtonElement) {
        addToCartButton.disabled = true;
      }

      return;
    }

    const variantInput = this.card.querySelector('product-form-component input[name="id"]');
    if (variantInput instanceof HTMLInputElement) {
      variantInput.value = variantId;
    }

    if (addToCartButton instanceof HTMLButtonElement) {
      addToCartButton.disabled = !available;
    }

    if (price) {
      const priceElement = this.card.querySelector('product-price [ref="priceContainer"] .price');
      if (priceElement) {
        priceElement.textContent = price;
      }
    }

    if (url) {
      for (const link of this.card.querySelectorAll('[ref="productCardLink"], [ref="cardGalleryLink"], [ref="productTitleLink"]')) {
        if (link instanceof HTMLAnchorElement) link.href = url;
      }
    }

    if (featuredMediaUrl) {
      this.card.setAttribute('data-featured-media-url', featuredMediaUrl);
    }

    const slideshow = this.card.refs?.slideshow;
    if (mediaId && slideshow) {
      const { slides = [] } = slideshow.refs;

      for (const slide of slides) {
        if (slide.getAttribute('variant-image') == null) continue;
        slide.hidden = slide.getAttribute('slide-id') !== mediaId;
      }

      slideshow.select({ id: mediaId }, undefined, { animate: false });
    }
  }
}

if (!customElements.get('product-card-variant-selector')) {
  customElements.define('product-card-variant-selector', ProductCardVariantSelector);
}
